/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_AwareInputs */

const en_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Change Aware`)
};

const fr_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basé sur les changements de plan`)
};

const de_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schusswechsel bewusst`)
};

const it_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consapevolezza del cambio di tiro`)
};

const ru_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Change Aware`)
};

const es_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de tiro consciente`)
};

const zh_cn2_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投篮变化感知`)
};

const ja_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットチェンジアウェア`)
};

const hi_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन के प्रति जागरूक`)
};

const pt_pt2_shot_change_aware = /** @type {(inputs: Shot_Change_AwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consciente da troca de injeções`)
};

/**
* | output |
* | --- |
* | "Shot Change Aware" |
*
* @param {Shot_Change_AwareInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_aware = /** @type {((inputs?: Shot_Change_AwareInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_AwareInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shot_change_aware(inputs)
	if (locale === "de") return de_shot_change_aware(inputs)
	if (locale === "it") return it_shot_change_aware(inputs)
	if (locale === "ru") return ru_shot_change_aware(inputs)
	if (locale === "es") return es_shot_change_aware(inputs)
	if (locale === "zh-CN") return zh_cn2_shot_change_aware(inputs)
	if (locale === "ja") return ja_shot_change_aware(inputs)
	if (locale === "hi") return hi_shot_change_aware(inputs)
	if (locale === "pt-PT") return pt_pt2_shot_change_aware(inputs)
	return en_shot_change_aware(inputs)
});